import { render } from "./ProjectStatistics.vue?vue&type=template&id=3b5b4088&scoped=true"
import script from "./ProjectStatistics.vue?vue&type=script&lang=js"
export * from "./ProjectStatistics.vue?vue&type=script&lang=js"

import "./ProjectStatistics.vue?vue&type=style&index=0&id=3b5b4088&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5b4088"]])

export default __exports__